import { Box, xcss } from '@atlaskit/primitives';
import React, { useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { ConfluenceLogo } from '@atlaskit/logo';
import { ExperienceStart } from '@atlassian/experience-tracker';
import { LoginToConfluenceIcon } from '../assets/LoginPageIconSVG';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import RefreshBanner from './RefreshBanner';
import messages from './messages';
const SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledParentDiv = styled.div({
  '': {
    display: 'inline-grid',
    alignItems: 'center',
    justifyItems: 'center',
    marginTop: "var(--ds-space-1000, 80px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledConfluenceIcon = styled(LoginToConfluenceIcon)({
  marginTop: "var(--ds-space-250, 20px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledConfluenceLoginText = styled.h2({
  '': {
    marginTop: "var(--ds-space-250, 20px)"
  }
});
const buttonWrapperStyles = xcss({
  marginTop: 'space.400'
});
const fadeIn = keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RefreshBannerFade = styled.div({
  padding: "var(--ds-space-250, 20px)",
  animation: `${fadeIn} 3s`
});
export const LoginPage = ({
  contentId,
  reloadEP,
  spaceKey,
  url
}) => {
  const {
    locale,
    formatMessage
  } = useIntl();
  const loginUrl = useMemo(() => {
    var _window, _window$location;
    const origin = url ? new URL(url).origin : (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin;
    return `${origin}/login?application=confluence&dest-url=${encodeURIComponent(`${SUCCESS_URL_SUFFIX}?locale=${locale}`)}`;
  }, [url, locale]);
  const handleClick = () => {
    openLoginPopup(loginUrl);
    setDisplayRefreshBanner(!displayRefreshBanner);
  };
  const [displayRefreshBanner, setDisplayRefreshBanner] = useState(false);
  return /*#__PURE__*/React.createElement(StyledParentDiv, null, /*#__PURE__*/React.createElement(ExperienceStart, {
    name: ExperienceNames.LOGIN_PAGE,
    id: `${spaceKey}-${contentId}`
  }), /*#__PURE__*/React.createElement(ConfluenceLogo, {
    size: "large",
    appearance: "brand"
  }), /*#__PURE__*/React.createElement(StyledConfluenceIcon, null), /*#__PURE__*/React.createElement(StyledConfluenceLoginText, null, formatMessage(messages.loginText)), /*#__PURE__*/React.createElement(Box, {
    xcss: buttonWrapperStyles
  }, /*#__PURE__*/React.createElement(Button, {
    testId: "login-button",
    "aria-label": formatMessage(messages.loginAriaLabel),
    appearance: "primary",
    onClick: handleClick
  }, formatMessage(messages.loginButton))), displayRefreshBanner && /*#__PURE__*/React.createElement(RefreshBannerFade, null, /*#__PURE__*/React.createElement(RefreshBanner, {
    reloadEP: reloadEP,
    title: formatMessage(messages.refreshBanner),
    actionLabel: formatMessage(messages.refreshBannerLink)
  })));
};
function openLoginPopup(loginUrl) {
  const windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
  window.open(loginUrl, '_blank', windowFeatures);
}